<template>
  <section>
    <div>
      <div class="slider-row">
        <div class="title-container">
          <h3>Formaat</h3>
          <!-- <button
            class="main-button right-btn"
            @click="$emit('showTemplates')"
            ng-hide="$parent.secure"
          >
            Templates
          </button> -->
        </div>
        <div id="format-slider" class="range-slider-group">
          <span class="slider-label left">{{ formats[0] }}</span>
          <span class="slider-label right">{{
            formats[formats.length - 1]
          }}</span>
          <range-slider
            :class="{
              'multi-selected':
                multiSelected.formats.length > 1 ||
                multiSelected.formats[0] === 'Als bestand'
            }"
            class="slider"
            min="0"
            :max="formats.length - 1"
            :model-value="formatSliderValue"
            @update:modelValue="setFormatPreview"
            @change="handleFormatChange"
          >
            <template #knob>
              <div
                v-if="multiSelected.formats.length > 1"
                class="inner-knob-multi"
              >
                ~
              </div>
              <div v-else-if="alsBestand" class="inner-knob-multi">
                <svg width="9px" height="11px" viewBox="0 0 9 11">
                  <title>als bestand</title>
                  <g
                    id="Page-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g id="ico-als-bestand-cl" stroke="var(--sub-color)">
                      <path
                        d="M8.5,3.36851378 L5.60382123,0.5 L1,0.5 C0.723857625,0.5 0.5,0.723857625 0.5,1 L0.5,10 C0.5,10.2761424 0.723857625,10.5 1,10.5 L8,10.5 C8.27614237,10.5 8.5,10.2761424 8.5,10 L8.5,3.36851378 Z"
                        id="path-1"
                      ></path>
                      <polyline
                        id="path-3"
                        transform="translate(6.500000, 2.500000) rotate(90.000000) translate(-6.500000, -2.500000) "
                        points="8 1 8 4 5 4"
                      ></polyline>
                    </g>
                  </g>
                </svg>
              </div>
              <div v-else class="inner-knob">
                {{ formatDisplayLabel }}
              </div>
            </template>
          </range-slider>
        </div>
        <button
          class="option-button format-button"
          :class="{
            active: alsBestand
          }"
          @click="handleFormatChange('Als bestand')"
        >
          Als bestand
        </button>
      </div>

      <div class="slider-row">
        <div class="title-container">
          <h3>Z/W of kleur</h3>
          <h3 class="title-right" v-show="specs.sideMode.length > 1">
            1- of 2-zijdig
          </h3>
        </div>

        <div id="color-slider" class="range-slider-group">
          <span class="slider-label left">z/w</span>
          <span class="slider-label right">kleur</span>
          <range-slider
            :class="{ 'multi-selected': multiSelected.colors.length > 1 }"
            class="slider"
            min="0"
            :max="specs.colorMode.length - 1"
            :model-value="color"
            @update:modelValue="setColorPreview"
            @change="handleColorChange"
          >
            <template #knob>
              <div
                v-if="multiSelected.colors.length > 1"
                class="inner-knob-multi"
              >
                ~
              </div>
              <div v-else class="inner-knob">
                {{ colorDisplayLabel }}
              </div>
            </template>
          </range-slider>
        </div>

        <div
          id="side-slider"
          class="range-slider-group"
          v-show="specs.sideMode.length > 1"
        >
          <span class="slider-label left">1z</span>
          <span class="slider-label right">2z</span>
          <range-slider
            :class="{ 'multi-selected': multiSelected.sides.length > 1 }"
            class="slider"
            min="0"
            :max="specs.sideMode.length - 1"
            :model-value="side"
            @update:modelValue="setSidePreview"
            @change="handleSideChange"
          >
            <template #knob>
              <div
                v-if="multiSelected.sides.length > 1"
                class="inner-knob-multi"
              >
                ~
              </div>
              <div v-else class="inner-knob">
                {{ sideDisplayLabel }}
              </div>
            </template>
          </range-slider>
        </div>
      </div>

      <div class="slider-row">
        <div class="title-container slider-title">
          <h3>Materiaal</h3>
          <h3 class="title-right" v-show="!paperType">Gewicht</h3>
        </div>
        <div id="paper-type-container" class="dual-button-remove">
          <button
            class="option-button open-menu"
            @click="$emit('showPaperTypes', specs.materials[0])"
            :class="{ active: paperType }"
          >
            {{ paperType ? paperType : 'Standaard ' }}
          </button>
          <button
            @click="
              () => {
                removePaperType()
                resetTemplate()
              }
            "
            class="remove-btn-white"
            @show="paperType"
          >
            <span></span>
          </button>
        </div>
        <div id="material-slider" class="range-slider-group">
          <span class="slider-label left">{{ specs.materials[0] }}</span>
          <span class="slider-label right">{{
            specs.materials[specs.materials.length - 1]
          }}</span>
          <range-slider
            :class="{
              'multi-selected': multiSelected.materials.length > 1 || paperType
            }"
            class="slider"
            min="0"
            :max="specs.materials.length - 1"
            :model-value="material"
            @update:modelValue="setMaterialPreview"
            @change="handleMaterialChange"
          >
            <template #knob>
              <div
                v-if="multiSelected.materials.length > 1 || paperType"
                class="inner-knob-multi"
              >
                ~
              </div>
              <div v-else class="inner-knob">
                {{ materialDisplayLabel }}
              </div>
            </template>
          </range-slider>
        </div>
      </div>
      <treatments-menu
        id="treatments"
        :specs="specs"
        :treatment="treatment"
        @setTreatment="setTreatment"
      ></treatments-menu>
    </div>
  </section>
</template>

<script>
import { RangeSlider } from '@/plugins/vue-range-slider'
import intersection from 'lodash-es/intersection'
import TreatmentsMenu from './TreatmentsMenu.vue'
import { useFileListStore } from '@/stores/FileList.store'
import { mapStores } from 'pinia'

export default {
  components: {
    RangeSlider,
    TreatmentsMenu
  },
  props: ['fullSpecs', 'selectedFiles'],
  data() {
    return {
      formats: Object.keys(this.fullSpecs)
        .filter(function (fm) {
          return fm !== 'Als bestand'
        })
        .reverse(),
      sliderPreview: {
        format: null,
        color: null,
        side: null,
        material: null
      }
    }
  },
  created() {},
  watch: {
    selectedFiles: {
      handler() {
        this.resetSliderPreview()
      },
      deep: true
    }
  },
  methods: {
    removePaperType() {
      this.fileListStore.updateFileSpec(
        this.fileNames,
        'material',
        this.specs['materials'][0]
      )

      this.fileListStore.updateFileSpec(this.fileNames, 'paperType', '')
    },
    resetTemplate() {
      this.removeProduct()
      this.fileListStore.updateFileSpec(this.fileNames, 'template', '')
    },
    removeProduct() {
      this.fileListStore.addProduct(this.fileNames, {})
    },
    setTreatment(treatment) {
      this.resetTemplate()

      this.fileListStore.updateFileSpec(this.fileNames, 'treatment', treatment)
    },
    getAvailableTreatments(spec) {
      if (!spec) {
        return []
      }

      const treatments = []

      if (Array.isArray(spec.treatments)) {
        treatments.push(...spec.treatments)

        spec.treatments.forEach((category) => {
          if (Array.isArray(spec[category])) {
            treatments.push(...spec[category])
          }
        })
      }

      return treatments
    },
    resetSliderPreview() {
      this.sliderPreview.format = null
      this.sliderPreview.color = null
      this.sliderPreview.side = null
      this.sliderPreview.material = null
    },
    checkSpecAvailability(forcedFormat) {
      const targetFormat =
        forcedFormat ||
        (this.multiSelected.formats.length === 1
          ? this.multiSelected.formats[0]
          : null)

      if (!targetFormat || !this.fullSpecs[targetFormat]) {
        return
      }

      const specsSource = this.fullSpecs[targetFormat]
      const validMaterials = Array.isArray(specsSource.materials)
        ? specsSource.materials
        : []
      const validSides = Array.isArray(specsSource.sideMode)
        ? specsSource.sideMode
        : []
      const validTreatments = this.getAvailableTreatments(specsSource)

      this.selectedFiles.forEach((file) => {
        const fileNames = [file.fileName]

        if (
          validSides.length > 0 &&
          file.side &&
          !validSides.includes(file.side)
        ) {
          this.fileListStore.updateFileSpec(fileNames, 'side', validSides[0])
        }

        if (
          validMaterials.length > 0 &&
          file.material &&
          !validMaterials.includes(file.material)
        ) {
          this.fileListStore.updateFileSpec(
            fileNames,
            'material',
            validMaterials[0]
          )
          this.fileListStore.updateFileSpec(fileNames, 'paperType', '')
        }

        if (
          validTreatments.length > 0 &&
          file.treatment &&
          !validTreatments.includes(file.treatment)
        ) {
          this.fileListStore.updateFileSpec(fileNames, 'treatment', '')
        }
      })
    },
    handleFormatChange(val) {
      if (!this.selectedFiles.length) {
        return
      }

      let format =
        val === 'Als bestand' ? 'Als bestand' : this.formats[Number(val)]

      if (!format) {
        return
      }

      this.resetTemplate()
      this.fileListStore.updateFileSpec(this.fileNames, 'format', format)

      if (['A0', 'A1', 'A2'].includes(format)) {
        this.applyFormatDefaultTreatment(format)
      }

      this.checkSpecAvailability(format)
      this.sliderPreview.format = null
    },
    setFormatPreview(val) {
      if (typeof val !== 'number') {
        return
      }
      this.sliderPreview.format = val
    },
    handleColorChange(val) {
      if (!this.selectedFiles.length || typeof val !== 'number') {
        return
      }

      const color = this.specs.colorMode[val]
      if (!color) {
        return
      }

      this.resetTemplate()
      this.fileListStore.updateFileSpec(this.fileNames, 'colorMode', color)
      this.sliderPreview.color = null
    },
    setColorPreview(val) {
      if (typeof val !== 'number') {
        return
      }
      this.sliderPreview.color = val
    },
    handleSideChange(val) {
      if (!this.selectedFiles.length || typeof val !== 'number') {
        return
      }

      const side = this.specs.sideMode[val]
      if (!side) {
        return
      }

      this.resetTemplate()
      this.fileListStore.updateFileSpec(this.fileNames, 'side', side)
      this.sliderPreview.side = null
    },
    setSidePreview(val) {
      if (typeof val !== 'number') {
        return
      }
      this.sliderPreview.side = val
    },
    handleMaterialChange(val) {
      if (!this.selectedFiles.length || typeof val !== 'number') {
        return
      }

      const material = this.specs.materials[val]
      if (!material) {
        return
      }

      this.resetTemplate()
      this.fileListStore.updateFileSpec(this.fileNames, 'material', material)
      this.fileListStore.updateFileSpec(this.fileNames, 'paperType', '')
      this.sliderPreview.material = null
    },
    setMaterialPreview(val) {
      if (typeof val !== 'number') {
        return
      }
      this.sliderPreview.material = val
    },
    applyFormatDefaultTreatment(format) {
      const spec = this.fullSpecs[format]
      if (!spec) {
        return
      }

      // Verzamel alle beschikbare afwerkingen voor dit formaat
      const availableTreatments = []

      // Voeg hoofdcategorieën toe uit treatments array (bijv. 'Rollen')
      if (spec.treatments && Array.isArray(spec.treatments)) {
        availableTreatments.push(...spec.treatments)
      }

      // Voeg ook alle sub-opties toe uit de treatment categorieën
      if (spec.treatments && Array.isArray(spec.treatments)) {
        spec.treatments.forEach(category => {
          if (spec[category] && Array.isArray(spec[category])) {
            availableTreatments.push(...spec[category])
          }
        })
      }

      // Check of de huidige afwerking nog beschikbaar is
      const currentTreatment = this.treatment
      const hasNoTreatment = !currentTreatment || currentTreatment === ''
      const isCurrentTreatmentAvailable = currentTreatment && availableTreatments.includes(currentTreatment)

      // Naar "A4 vouwen" switchen als:
      // 1. Er is nog geen afwerking geselecteerd, OF
      // 2. De huidige afwerking is NIET beschikbaar bij dit formaat
      if ((hasNoTreatment || !isCurrentTreatmentAvailable) && availableTreatments.includes('A4 vouwen')) {
        this.fileListStore.updateFileSpec(
          this.fileNames,
          'treatment',
          'A4 vouwen'
        )
      }
    }
  },
  computed: {
    ...mapStores(useFileListStore),
    fileNames() {
      let fileNames = []
      this.selectedFiles.forEach((file) => {
        fileNames.push(file.fileName)
      })

      return fileNames
    },
    alsBestand() {
      return this.multiSelected.formats.length === 1 &&
        this.multiSelected.formats[0] === 'Als bestand'
        ? true
        : false
    },
    multiSelected() {
      let selectedFormats = []
      let selectedColors = []
      let selectedSides = []
      let selectedMaterials = []
      let selectedTreatments = []

      this.selectedFiles.forEach((file) => {
        if (selectedFormats.indexOf(file.format) < 0) {
          selectedFormats.push(file.format)
        }
        if (selectedColors.indexOf(file.colorMode) < 0) {
          selectedColors.push(file.colorMode)
        }
        if (selectedSides.indexOf(file.side) < 0) {
          selectedSides.push(file.side)
        }
        if (selectedMaterials.indexOf(file.material) < 0) {
          selectedMaterials.push(file.material)
        }
        if (selectedTreatments.indexOf(file.treatment) < 0) {
          selectedTreatments.push(file.treatment)
        }
      })

      return {
        formats: selectedFormats,
        colors: selectedColors,
        sides: selectedSides,
        materials: selectedMaterials,
        treatments: selectedTreatments
      }
    },
    specs() {
      let format
      if (this.multiSelected.formats.length === 1) {
        format =
          this.format === 'Als bestand'
            ? 'Als bestand'
            : this.formats[this.format]

        format = Object.prototype.hasOwnProperty.call(this.fullSpecs, format)
          ? format
          : this.formats[0]

        this.$emit('setPaperTypes', this.fullSpecs[format].paperType)
        return this.fullSpecs[format]
      } else {
        let specsArrays = []
        let specs = []

        this.multiSelected.formats.forEach((fm) => {
          Object.keys(this.fullSpecs[fm]).forEach((key) => {
            if (specsArrays[key] === undefined) {
              specsArrays[key] = []
            }
            specsArrays[key].push(this.fullSpecs[fm][key])
          })
        })
        Object.keys(specsArrays).forEach((key, index) => {
          if (specsArrays[key].length === this.multiSelected.formats.length) {
            specs[key] = intersection(...specsArrays[key])
          }
        })
        this.$emit('setPaperTypes', specs.paperType)

        return specs
      }
    },
    format() {
      if (this.multiSelected.formats.length !== 1) {
        return
      }

      const currentFormat = this.multiSelected.formats[0]
      if (currentFormat === 'Als bestand') {
        return 'Als bestand'
      }

      return this.formats.indexOf(currentFormat)
    },
    color() {
      if (this.multiSelected.colors.length !== 1) {
        return
      }

      return this.specs.colorMode.indexOf(this.multiSelected.colors[0])
    },
    side() {
      if (this.multiSelected.sides.length !== 1) {
        return
      }

      return this.specs.sideMode.indexOf(this.multiSelected.sides[0])
    },
    material() {
      if (this.paperType || this.multiSelected.materials.length !== 1) {
        return
      }

      return this.specs.materials.indexOf(this.multiSelected.materials[0])
    },
    formatDisplayIndex() {
      if (
        this.sliderPreview.format !== null &&
        this.sliderPreview.format !== undefined
      ) {
        return this.sliderPreview.format
      }

      return typeof this.format === 'number' ? this.format : null
    },
    formatDisplayLabel() {
      if (this.formatDisplayIndex === null || this.formatDisplayIndex === undefined) {
        return ''
      }

      return this.formats[this.formatDisplayIndex]
    },
    colorDisplayIndex() {
      if (this.sliderPreview.color !== null && this.sliderPreview.color !== undefined) {
        return this.sliderPreview.color
      }

      return this.color
    },
    colorDisplayLabel() {
      if (this.colorDisplayIndex === null || this.colorDisplayIndex === undefined) {
        return ''
      }

      const mode = this.specs.colorMode[this.colorDisplayIndex]
      return mode === 'Zwart/Wit' ? 'z/w' : 'kleur'
    },
    sideDisplayIndex() {
      if (this.sliderPreview.side !== null && this.sliderPreview.side !== undefined) {
        return this.sliderPreview.side
      }

      return this.side
    },
    sideDisplayLabel() {
      if (this.sideDisplayIndex === null || this.sideDisplayIndex === undefined) {
        return ''
      }

      const side = this.specs.sideMode[this.sideDisplayIndex]
      return side === 'Enkelzijdig' ? '1z' : '2z'
    },
    materialDisplayIndex() {
      if (this.sliderPreview.material !== null && this.sliderPreview.material !== undefined) {
        return this.sliderPreview.material
      }

      return this.material
    },
    materialDisplayLabel() {
      if (this.materialDisplayIndex === null || this.materialDisplayIndex === undefined) {
        return ''
      }

      return this.specs.materials[this.materialDisplayIndex]
    },
    formatSliderValue() {
      if (
        this.sliderPreview.format !== null &&
        this.sliderPreview.format !== undefined
      ) {
        return this.sliderPreview.format
      }

      if (typeof this.format === 'number') {
        return this.format
      }

      return Math.floor((this.formats.length - 1) / 2)
    },
    paperType() {
      if (
        this.multiSelected.materials.length === 1 &&
        this.specs.paperType.indexOf(this.multiSelected.materials[0]) > -1
      ) {
        this.$emit('setCurPaperType', this.multiSelected.materials[0])
        return this.multiSelected.materials[0]
      } else {
        this.$emit('setCurPaperType', '')
        return ''
      }
    },
    treatment() {
      if (this.multiSelected.treatments.length > 1) {
        return
      } else {
        return this.multiSelected.treatments[0]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.range-slider-group {
  //margin-left: 17px;
  &:nth-child(3) {
    margin-right: 20px;
  }
}

#format-slider {
  width: 86px;
}

.format-button {
  margin-right: -10px;
  margin-left: 30px;
  border-radius: 50px;
  height: 30px;
  margin-top: 3px;
}

#color-slider {
  width: 50px;
}

#side-slider {
  width: 50px;
  margin-left: 65px;
}

.slider-row {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

#paper-type-container {
  display: inline-block;
  margin-left: -8px;
  width: 90px;
  margin-right: 7px;
  margin-top: 3px;
}

#material-slider {
  width: 75px;
}

.dual-button-remove {
  position: relative;

  button:first-child {
    padding-right: 16px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 30px;
  }

  button:nth-child(2) {
    position: absolute;
    right: 6px;
    top: 11px;
  }
}

#treatments {
  min-height: 93px;
}

:deep(.multi-selected) {
  // Keep "~" indicator, but allow knob to follow pointer
}
</style>
